define.alias("shared/components/shared/period-time-picker", "calendar/components/shared/period-time-picker");